/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubjectService {

  constructor() { }

  currentSubject$ = new BehaviorSubject(false);
  private redCalidadSubject = new Subject<{ isOk: boolean; payload?: any }>();
  redCalidad$ = this.redCalidadSubject.asObservable();

  //actualizar menu de usuario conforme al rol
  menuEvento() {

    this.currentSubject$.next(true);

  }

  desconexionEvento(bandera) {
    this.currentSubject$.next(bandera);
  }

  redCalidadEvento(data: any) {
    this.redCalidadSubject.next(data);
  }
}
